import {
  ChannelInfo,
  SuccessChannelInfo,
  ErrorChannelInfo,
} from '../../../../../models/CheckChannels/CheckChannels'

export default class ChannelsInfoHelper {
  static Channels: Array<ChannelInfo> = []

  static GetChannel(value: string): ChannelInfo | undefined {
    return this.Channels.find((c) => {
      if (c instanceof ErrorChannelInfo && c.value === value) {
        return c
      }

      if (c instanceof SuccessChannelInfo) {
        if (c.value === value) {
          return c
        }

        if (c.info.id === Number(value)) {
          return c
        }

        if (c.info.login && c.info.login.includes(value)) {
          return c
        }
      }
    })
  }
}
